import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { API_URL } from "../../constants/url";
import AppleIcon from "@mui/icons-material/Apple";
import ShopIcon from "@mui/icons-material/Shop";
import "./Public.scss";
import { formatPhoneLtr } from "../../utils/phoneDisplay";

const PUBLIC_API_URL = API_URL.replace(/\/admin\/?$/, "/user/public/");

const PublicAgent = () => {
  const { id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isArabic = searchParams.get("lang") === "ar";
  const [agent, setAgent] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${PUBLIC_API_URL}agent/${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.data) {
          setAgent(data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <div className="public-container"><div className="loader">Loading...</div></div>;
  }

  if (!agent) {
    return <div className="public-container"><h1>Agent not found</h1></div>;
  }

  return (
    <div className="public-container">
      <div className="public-card agent-card">
        <div className="agent-header">
          {agent.profilePic ? (
            <img src={agent.profilePic} alt={agent.fullName} className="agent-profile-pic" />
          ) : (
            <div className="agent-placeholder">{agent.fullName?.charAt(0) || 'A'}</div>
          )}
          <h1 className="agent-title">{agent.fullName}</h1>
          {agent.countryCode && agent.phone && (
            <p className="agent-contact" dir="ltr">
              {formatPhoneLtr(agent.countryCode, agent.phone)}
            </p>
          )}
          {agent.email && (
            <p className="agent-contact">{agent.email}</p>
          )}
          
          {agent.totalPropertyCount !== undefined && (
            <div className="agent-stats">
              <span className="stat-value">{agent.totalPropertyCount}</span>
              <span className="stat-label">{isArabic ? "العقارات المدرجة" : "Properties Listed"}</span>
            </div>
          )}
        </div>
        <div className="content">
          <div className="section-header">{isArabic ? "عن" : "About"}</div>
          <p className="agent-bio">
            {isArabic ? (
              <>عرض كل العقارات المدرجة بواسطة <strong>{agent.fullName}</strong> وتواصل مباشرة عبر التطبيق.</>
            ) : (
              <>View all properties listed by <strong>{agent.fullName}</strong> and get in touch directly through the app.</>
            )}
          </p>
          
          <div className="download-section">
            <h3 className="download-title">{isArabic ? "قم بتنزيل التطبيق للاتصال بالوكيل" : "Download App to Contact Agent"}</h3>
            <div className="store-buttons">
              <a href="https://www.apple.com/app-store/" className="store-btn apple" target="_blank" rel="noopener noreferrer">
                <AppleIcon />
                <div className="btn-text">
                  <small>{isArabic ? "تحميل على" : "Download on the"}</small>
                  <span>App Store</span>
                </div>
              </a>
              <a href="https://play.google.com/store/apps" className="store-btn google" target="_blank" rel="noopener noreferrer">
                <ShopIcon />
                <div className="btn-text">
                  <small>{isArabic ? "احصل عليه من" : "GET IT ON"}</small>
                  <span>Google Play</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicAgent;
